import { gql } from '__generated__'

export const GetTitleOptions = gql(/* GraphQL */ `
    query GetTitleOptions {
        titles {
            id
            value
        }
    }
`)
